import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio43: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="aspect-ratio-4-3, landscape"><path d="M2.75 4.75H21.25V19.25H2.75V4.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAspectRatio43;
